<template>
<div>

    <section class="content">

      <!-- Default box -->
      <div class="info-box" v-if="canAccess('software-timing-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Software Timing</h3>
          <span class="float-right">
            <button type="button" class="btn btn-sm btn-primary float-right" v-if="canAccess('software-timing-update')" @click="editModal(softwareTimings)" > <i class="fa fa-pencil"></i></button>
          </span>

          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
          <table class="table table-sm">
              <thead>
                <tr>
                  <th>Software Time In</th>
                  <th>{{ softwareTimings.inTime }}</th>
                </tr>

                <tr>
                  <th>Software Time Out</th>
                  <th>{{ softwareTimings.outTime }}</th>
                </tr>
                <tr>
                  <th>Status</th>
                  <th v-if="softwareTimings.status == 'active'">
                    <span class="label label-success">Active</span>
                  </th>
                  <th v-else><span class="label label-danger">InActive</span></th>
                </tr>
              </thead>
            </table>
                
        </div>
        <!-- /.box-body -->
      </div>
      <!-- /.box -->

    </section>
  
      <div class="modal fade" id="newModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Update Software Timing</h4>
            </div>
            <form @submit.prevent="updateSoftwareTiming()">
              <div class="modal-body">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group">
                            <label>Time In <span class="red">*</span></label>
                            <input
                              v-model="form.inTime"
                              type="text"
                              name="inTime"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('inTime'),
                              }"
                            />
                            <has-error :form="form" field="inTime"></has-error>
                          </div>

                          <div class="form-group">
                            <label>Time Out <span class="red">*</span></label>
                            <input
                              v-model="form.outTime"
                              type="text"
                              name="outTime"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('outTime'),
                              }"
                            />
                            <has-error :form="form" field="outTime"></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label
                              >Select Status <span class="red">*</span></label
                            >
                            <select
                              v-model="form.status"
                              name="status"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('status'),
                              }"
                            >
                              <option v-if="!form.status" selected value="">
                                Select Status
                              </option>
                              <option value="active">Active</option>
                              <option value="inActive">Inactive</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  SAVE TIMING
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      
</div>
</template>

<script>
export default {
  name: 'SoftwareTiming',
  data () {
    return {
      form: new Form({
        id: '',
        inTime: '',
        outTime: '',
        status: ''
      }),
      softwareTimings: {}
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    editModal (softwareTimings) {
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(softwareTimings)
    },
    updateSoftwareTiming () {
      // console.log('update data');

      this.$axios
        .put('softwaretiming/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Software Timing Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadData () {
      let loader = this.$loading.show()
      this.$axios
        .get('softwaretiming?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data);
          loader.hide()
          this.softwareTimings = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.loadData()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>
<style scoped>
.content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// SoftwareTiming.vue?b695631e